import toDate from '../to-date';

export const getSeconds = (date: Date | number): number => {
  const formattedDate = toDate(date);

  return formattedDate.getSeconds();
};

export default getSeconds;
